import { axios } from '@/lib/axios';
import { useMutation, useQueryClient } from 'react-query';
import { useNotificationStore } from '@/stores/notifications';
import { Translation } from '@/features/Translations/types';
import { useNavigate } from 'react-router-dom';

type AddTranslationGroupData = {
    data: {
        key: string;
        title: string;
    };
};

export const addTranslationGroup = ({ data }: AddTranslationGroupData): Promise<Translation> => {
    return axios.post(`/api/admin/site_translation/group/create`, data);
};

export const useAddTranslationGroup = () => {
    const { addNotification } = useNotificationStore();
    const queryClient = useQueryClient();

    const navigate = useNavigate();

    return useMutation({
        onMutate: async (updatingCollection: any) => {
            await queryClient.cancelQueries(['group', updatingCollection?.id]);
        },
        onError: (_, __, context: any) => {
            addNotification({
                type: 'error',
                title: 'Unable to create translation group',
            });
        },
        onSuccess: (res) => {
            queryClient.refetchQueries(['group', res.id]);
            addNotification({
                type: 'success',
                title: 'Group successfully created',
            });
            navigate(`/translations/groups`);
        },

        mutationFn: addTranslationGroup,
    });
};
